import { render } from "./index.vue?vue&type=template&id=1016173e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1016173e&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1016173e"]])

export default __exports__